module.exports = __webpack_public_path__ + "static/media/edit.89d48e9c.svg";